import Axios from "axios";
import { decryptToken, encryptToken } from "./globals";
import { setLogout } from "../store/slices/UserSlice";
import { store } from "../store";
import { toast } from "react-toastify";
import _ from "lodash";

const api = Axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 300000,
  headers: {
    'x-api-key': "dWeUTGaj0G2FP6rK3B3oCmHKAP9j1n4n"
  },
});

let isRefreshing = false;
let refreshQueue = [];

const redirectToLogin = () => {
  localStorage.removeItem("AccessToken");
  localStorage.removeItem("RefreshToken");
  store.dispatch(setLogout());
  document.title = "Attendance portal";
};

const refreshToken = async () => {
  const refresh_token = localStorage.getItem("RefreshToken");

  if (!refresh_token) {
    redirectToLogin();
    throw new Error("No refresh token found");
  }

  const encryptedRefreshToken = decryptToken(refresh_token);

  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/member/refresh`,
      {},
      {
        headers: {
          "X-Refresh-Token": encryptedRefreshToken,
          'x-api-key': "dWeUTGaj0G2FP6rK3B3oCmHKAP9j1n4n"
        },
      }
    );

    if (response.status !== 200) {
      redirectToLogin();
      throw new Error(
        `Refresh token request failed with status ${response.status}`
      );
    }

    const { AccessToken, RefreshToken } = response.data.Result;
    const decryptedToken = encryptToken(AccessToken);
    const decryptedRefreshToken = encryptToken(RefreshToken);

    localStorage.setItem("AccessToken", decryptedToken);
    localStorage.setItem("RefreshToken", decryptedRefreshToken);

    refreshQueue.forEach((request) => request());
    refreshQueue = [];

    return AccessToken;
  } catch (error) {
    redirectToLogin();
    throw error;
  }
};

api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("AccessToken");

    if (token) {
      const decryptedToken = decryptToken(token);
      config.headers.Authorization = `Bearer ${decryptedToken}`;
    }
    return config;
  },
  (err) => Promise.reject(err)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;

        try {
          const newToken = await refreshToken();
          originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
          return api.request(originalRequest);
        } catch (refreshError) {
          redirectToLogin();
          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      } else {
        return new Promise((resolve) => {
          refreshQueue.push(() => {
            originalRequest.headers["Authorization"] = `Bearer ${localStorage.getItem("AccessToken")}`;
            resolve(api.request(originalRequest));
          });
        });
      }
    } else {
      if (error.response && error.response.status !== 401 && error.response.status !== 404 && _.isEmpty(error.response.data.Message)) {
        toast.error(
          <>
            <div>{originalRequest.url.split("/").pop()}</div>
            <div>{error.message}</div>
          </>
        );
      }

      return Promise.reject(error);
    }
  }
);

export default api;



